import authModule from '@/store/auth'

export function validateRole(roles: string[]) {
  if (!Array.isArray(roles)) return false
  const roles_to_user: { name: string }[] = authModule.Roles
  return roles_to_user.some((r) => roles.indexOf(r.name) >= 0)
}
